import { createGlobalStyle } from 'styled-components';

const ShowCrispUpperBottomActionBar = createGlobalStyle`
body .crisp-client .cc-kv6t .cc-1xry .cc-unoo {
  bottom: 80px !important;
}

body .crisp-client .cc-kv6t[data-full-view=true] .cc-1xry .cc-unoo {
 bottom: 80px !important;
}

body .crisp-client .cc-kv6t[data-full-view=true] .cc-1xry .cc-ge4v  {
  z-index: 999999999 !important;
}


body .crisp-client .cc-kv6t[data-full-view=true] .cc-1xry .cc-unoo .cc-1c9v .cc-1bue  {
   bottom: 130px !important;
}

body .crisp-client .cc-kv6t .cc-1xry .cc-unoo .cc-1c9v .cc-1bue  {
    bottom: 150px !important;
}
`;

export default ShowCrispUpperBottomActionBar;
